<template>
  <div class="pay-wrapper" :class="expiredDate ? 'pay-padding' : ''">
    <div class="pay-price leading-6">
      <PayMoneyDiscount :text="text" :discount="88" v-if="isDiscount && from === 'buy-credit'" />
      <PayMoney :text="text" v-else />
    </div>

    <div class="pay-discount" v-if="showDiscountCountdown && discountRemainingTime > 0">
      {{ $t('xian-shi-te-hui-countdown', [countdown]) }}
    </div>

    <div class="pay-info">
      <span v-if="rightName">{{ $t('suo-xuan-tao-can-rightname', [rightName]) }}</span>
      <span v-show="expiredDate">{{ $t('you-xiao-qi-expireddate', [expiredDate]) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts" name="PayPrice">
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { usePayment } from '../store';
import PayMoney from './PayMoney.vue';
import PayMoneyDiscount from './PayMoneyDiscount.vue';

dayjs.extend(duration);

const paymentStore = usePayment();
const { discountRemainingTime, isDiscount } = storeToRefs(paymentStore);

const countdown = computed(() => {
  return dayjs.duration(discountRemainingTime.value, 'seconds').format('HH:mm:ss');
});

defineProps<{
  text: number;
  expiredDate?: string;
  rightName?: string;
  showDiscountCountdown?: boolean;
  from?: string; // buy-credit
}>();
</script>

<style lang="scss" scoped>
.pay-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pay-discount {
  font-size: var(--x-text-12-size);
  color: var(--x-white-1);
  text-align: center;
  line-height: 22px;
  border-radius: var(--x-radius-small);
  background-color: var(--x-error-6);
  display: inline-block;
  padding-inline: 6px;
  margin: 10px auto;
  font-variant-numeric: tabular-nums; // 确保数字等宽，避免滚动时抖动
}
.time {
  font-size: 14px;
}
.pay-price {
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
}
.pay-info {
  display: flex;
  flex-direction: column;
  margin: 6px auto 0;
  gap: 6px;
  width: 180px;
  justify-content: center;
  align-items: flex-start;
  font-size: var(--x-text-12-size);
  font-weight: 400;
  line-height: var(--x-text-12-line-height);
  color: var(--x-text-3);
}
.pay-line {
  height: 1px;
  border: 1px solid var(--x-back-5);
  opacity: 0.29;
}
.time {
  font-size: 12px;
}
</style>
